<div class="flex flex-col gap-3">
  <div class="flex items-center justify-between px-[8px]">
    <h2 class="title text-[18px] font-semibold" i18n="@@breadcrumbBankAccount">Bank Account</h2>

    <a
      routerLink="/admin/bank-account/add-bank-account"
      class="add-button flex items-center justify-center gap-2">
      <app-add-icon />
      <span i18n="@@breadcrumbAddBankAccount">Create Bank Account</span>
    </a>
  </div>

  <app-bank-accounts-list />
</div>
